export class ChangePassword {
    public gUID: string;
    public userName: string;
    public entityTypeId: number;
    public referenceEntityId: number;
    public existingPassword: string;
    public newPassword: string;
}